export default __webpack_public_path__ + "static/media/aral_komfort.af97d89f.svg";